module.exports = __webpack_public_path__ + "media/career/Max-Mustermann-b02340ae.webp";